import {
  AgreementCode,
  AkaAgreements,
  CollectiveAgreements,
  CoopAgreements,
  DanskeBankMigratedAgreements,
  DanskeBankNewAgreements,
  HuseierneAgreements,
  UnlimitedYearlyKmNeedAgreements,
} from 'Constants/agreementCodes.constants';

export const isAkaAgreement = (agreementProduct: AgreementCode): boolean =>
  AkaAgreements.includes(agreementProduct);

export const isCoopAgreement = (agreementProduct: AgreementCode): boolean =>
  CoopAgreements.includes(agreementProduct);

export const isMigratedDanskeBankAgreement = (
  agreementProduct: AgreementCode,
): boolean => DanskeBankMigratedAgreements.includes(agreementProduct);

export const isNewDanskeBankAgreement = (
  agreementProduct: AgreementCode,
): boolean => DanskeBankNewAgreements.includes(agreementProduct);

export const isHuseierneAgreement = (
  agreementProduct: AgreementCode,
): boolean => HuseierneAgreements.includes(agreementProduct);

export const isElbilforeningAgreement = (
  agreementProduct: AgreementCode,
): boolean => AgreementCode.NORSKELBILFORENING === agreementProduct;

export const isCollectiveDiscountCustomer = (
  agreementProduct: AgreementCode,
): boolean => CollectiveAgreements.includes(agreementProduct);

export const isAdvantageousCustomer = (
  agreementProduct: AgreementCode,
): boolean => AgreementCode.FFA_PROGRAM === agreementProduct;

export const isUnlimitedYearlyKmNeedAgreement = (
  agreementProduct: AgreementCode,
): boolean => UnlimitedYearlyKmNeedAgreements.includes(agreementProduct);
